/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import InstitutesSettingsRouteLinkItem from './InstitutesSettingsRouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.institutes.reports'},
});

const ReportsItem = () => (
  <InstitutesSettingsRouteLinkItem
    route="midas/settings/institutes/reports"
    title={messages.title}
  />
);

export default ReportsItem;
